/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSigintSensorSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetSigintSensorSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetSigintSensorSecurity = {
  option1?: GetSigintSensorSecurityOption1 | undefined;
  option2?: GetSigintSensorSecurityOption2 | undefined;
};

export type GetSigintSensorRequest = {
  /**
   * Sensor ID
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetSigintSensorSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetSigintSensorSecurityOption1$outboundSchema: z.ZodMiniType<
  GetSigintSensorSecurityOption1$Outbound,
  GetSigintSensorSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSigintSensorSecurityOption1ToJSON(
  getSigintSensorSecurityOption1: GetSigintSensorSecurityOption1,
): string {
  return JSON.stringify(
    GetSigintSensorSecurityOption1$outboundSchema.parse(
      getSigintSensorSecurityOption1,
    ),
  );
}

/** @internal */
export type GetSigintSensorSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetSigintSensorSecurityOption2$outboundSchema: z.ZodMiniType<
  GetSigintSensorSecurityOption2$Outbound,
  GetSigintSensorSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getSigintSensorSecurityOption2ToJSON(
  getSigintSensorSecurityOption2: GetSigintSensorSecurityOption2,
): string {
  return JSON.stringify(
    GetSigintSensorSecurityOption2$outboundSchema.parse(
      getSigintSensorSecurityOption2,
    ),
  );
}

/** @internal */
export type GetSigintSensorSecurity$Outbound = {
  Option1?: GetSigintSensorSecurityOption1$Outbound | undefined;
  Option2?: GetSigintSensorSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetSigintSensorSecurity$outboundSchema: z.ZodMiniType<
  GetSigintSensorSecurity$Outbound,
  GetSigintSensorSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetSigintSensorSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetSigintSensorSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getSigintSensorSecurityToJSON(
  getSigintSensorSecurity: GetSigintSensorSecurity,
): string {
  return JSON.stringify(
    GetSigintSensorSecurity$outboundSchema.parse(getSigintSensorSecurity),
  );
}

/** @internal */
export type GetSigintSensorRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetSigintSensorRequest$outboundSchema: z.ZodMiniType<
  GetSigintSensorRequest$Outbound,
  GetSigintSensorRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getSigintSensorRequestToJSON(
  getSigintSensorRequest: GetSigintSensorRequest,
): string {
  return JSON.stringify(
    GetSigintSensorRequest$outboundSchema.parse(getSigintSensorRequest),
  );
}
